import { useAppState } from "@/store/useApp";
import PanelLayout from "./side-panel/PanelLayout";
import { useAppDispatch } from "@/store/useApp";

export const DiscrepanciesPanel = () => {
  const dispatch = useAppDispatch();
  const currentDocument = useAppState((state) => state.currentDocument);
  const isDiscrepanciesPanelOpen = useAppState((state) => state.isDiscrepanciesPanelOpen);

  if (!currentDocument?.validation || currentDocument.validation.passed) {
    return null;
  }

  if (!isDiscrepanciesPanelOpen) {
    return null;
  } 

  const handleClose = () => {
    dispatch({ type: "TOGGLE_DISCREPANCIES_PANEL" });
  }

  return (
    <PanelLayout 
      title="Discrepancies" 
      description={
        <span>
          We found some discrepancies between the source PDF and how the text is displayed in Claire, please verify.
          <a
            href="https://docs.clairelabs.ai/safeguard/instructions-for-use#text-discrepancies"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 text-muted-foreground underline"
          >
            Learn more here.
          </a>
        </span>
      }
      onClose={handleClose}
    >
      <ol className="space-y-4 list-decimal list-inside pl-0">
        {currentDocument.validation.issues.map((issue, index) => (
          <li
            key={index}
            className="pl-4 space-y-2"
          >
              {issue.issueType}
            
            <div className="text-sm text-gray-500">
              Location: {issue.location}
            </div>
            
            {issue.description && (
              <div className="text-sm text-gray-600">
                {issue.description}
              </div>
            )}

            <div className="space-y-2">
              <div className="space-y-1">
                <div className="text-xs font-medium text-gray-500 uppercase">
                  Original
                </div>
                <div className="text-sm text-gray-700 bg-gray-50 rounded p-2 whitespace-pre-wrap">
                  {issue.original}
                </div>
              </div>

              <div className="space-y-1">
                <div className="text-xs font-medium text-gray-500 uppercase">
                  Processed
                </div>
                <div className="text-sm text-gray-700 bg-gray-50 rounded p-2 whitespace-pre-wrap">
                  {issue.processed}
                </div>
              </div>
            </div>
          </li>
        ))}
        
        {currentDocument.validation.issues.length === 0 && (
          <div className="text-center text-gray-500 py-8">
            No discrepancies found
          </div>
        )}
      </ol>
    </PanelLayout>
  );
};

